import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import classNames from 'classnames'
import React, { ReactElement, ReactNode } from 'react'
import { IconFa } from '../icon-fa'

interface Props {
  onClose: () => void
  open: boolean
  className?: string
  title: string
  initialFocus?: React.MutableRefObject<HTMLButtonElement | null>
  children: ReactNode
  closeText: string
}

export function PlainModal(props: Props): ReactElement {
  const closeButton = (
    <button
      type="button"
      aria-label={props.closeText}
      onClick={props.onClose}
      className="absolute top-0 right-0 px-3 py-2 cursor-pointer font-semibold text-base text-emphasis-extra"
    >
      <IconFa icon={['far', 'times']} title={props.closeText} />
    </button>
  )

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      initialFocus={props.initialFocus}
      className="relative z-40"
      aria-label={props.title}
    >
      <DialogBackdrop className="fixed inset-0 bg-black opacity-20" />
      <div className="fixed inset-0 flex items-center justify-center min-h-screen text-base overflow-y-auto">
        <DialogPanel
          className={classNames(
            props.className,
            'relative grid pt-10 rounded-xs shadow-dark bg-theme-surface overflow-x-hidden'
          )}
        >
          {props.children}
          {closeButton}
        </DialogPanel>
      </div>
    </Dialog>
  )
}
